import React, { useState, useEffect, useRef } from "react";
import ImagingHeader from "./ImagingHeader";
import ImagingFooter from "./ImagingFooter";
import TopNav from "../TopNav/TopNav";
import NewImagineTop from "./NewImagineTop";
import SubFooter from "../SubFooter/SubFooter";
import { Scroll } from "../Scroll function/scroll";
import SimpleForm from "../chatbot/SimpleForm";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import Content from "../../Pages/homePage/Components/Content";
import ImagingNewHeader from "./ImagingNewHeader";
import card1 from "../../Assets/newAsset/imaging/mri.svg";
import pet from "../../Assets/newAsset/imaging/pet.svg";
import ct from "../../Assets/newAsset/imaging/ct.svg";
import ultrasound from "../../Assets/newAsset/imaging/ultrasound.svg";
import mamory from "../../Assets/newAsset/imaging/mammography.svg";
import { connect } from "react-redux";
import FAQforhomepage from "../../Pages/homePage/FAQforhomepage";
import ContactUsNew from "../../Pages/homePage/Components/ContactUsNew";
import { Modal } from "react-responsive-modal";
import Featured from "../../Pages/homePage/Components/Featured";
// import LpForm from "../../Pages/packageDetailsPage/LpForm";
import ImagingForm from "./ImagingForm";
import miniLogo from "../../Assets/newAsset/career/minilogo.jpg";
import doc from "../../Assets/newAsset/imaging/professional-doctor-radiologist-medical-laboratory-1.webp";
import "./Imaging.css";
import FAQstructure from "../../Pages/homePage/FAQstructure";
import "../../Pages/homePage/TestCr.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import profile1 from "../../Assets/newAsset/TestiProfile.webp";
import sam from "../../Assets/newAsset/imaging/sam.webp";
import { useLocation } from "react-router";
import "../../../src/Pages/homePage/Components/Content.css";
import cart_empty from "../../Assets/cart_empty.svg";
import cart_fill from "../../Assets/cart_fill.svg";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import AddressPopUp from "./AddressPopUp";
import { SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS } from "../../Redux/Constants";
import {
  getAllImagingPackageList,
  ImagingPackageList,
  Imaginetestimonials,
} from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import tmt from "../../../src/Assets/newAsset/imaging/ecg.svg";
import xray from "../../../src/Assets/newAsset/imaging/outline.svg";
import echo from "../../../src/Assets/newAsset/imaging/Soundassistant.svg";
import mriM from "../../../src/Assets/newAsset/imaging/mriM.svg";
import ctM from "../../../src/Assets/newAsset/imaging/ctM.svg";
import peetM from "../../../src/Assets/newAsset/imaging/peetM.svg";
import ultrasoundM from "../../../src/Assets/newAsset/imaging/ultrasoundM.svg";
import mammographyM from "../../../src/Assets/newAsset/imaging/mammographyM.svg";
import ImagingLpForm from "./Homepage/ImagingLpForm";
import Meta from "../Meta";
import TestimonialNew from "../../Pages/homePage/Components/TestimonialNew";

// import  "../../Pages/HealthPackagePage/Component/"

//PACKAGE DATA
const packageData = [
  {
    id: 1,
    title: "MRI SCAN",

    listDesc: [
      "Total no.of Tests - 42",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "2740",
    startsfrom: "650",
    isPremium: false,
    slug: "advance-plus-full-body-checkup",
    rightTitle: "Economical Plan",
  },
  {
    id: 2,
    title: "Smart Full Body Checkup",
    rightTitle: "Most Popular Plan",
    listDesc: [
      "Total no.of Tests",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1479",
    startsfrom: "699",
    isPremium: true,
  },
  {
    id: 3,
    title: "Covid - 19 RTPCR Test",

    listDesc: [
      "Total no.of Test",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1999",
    startsfrom: "720",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
  {
    id: 4,
    title: "Fever Panel ",

    listDesc: [
      "Total no.of Tests",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1740",
    startsfrom: "650",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
  {
    id: 5,
    title: "Full Body Checkup",
    rightTitle: "Most Popular Plan",
    listDesc: [
      "Total no.of Tests",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "1599",
    startsfrom: "799",
    isPremium: true,
  },
  {
    id: 6,
    title: "Covid - 19 RTPCR Test",

    listDesc: [
      "Total no.of Test",
      "Quick Turn Around Time",
      "Reporting as per NABL ISO guidelines",
    ],
    mrp: "2999",
    startsfrom: "800",
    isPremium: false,
    rightTitle: "Economical Plan",
  },
];
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1500, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const Ourpackages = (props) => {
  console.log("PROPS", props);
  const { Cards } = props;
  const [ItemInCart, setItemInCart] = useState([]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const onOpenModal = () => {
    setOpen(true);
  };
  const onCloseModal = () => setOpen(false);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const [cartClick, setCartClick] = useState(false);
  const [cardSlug, setCardSlug] = useState("");

  console.log("=====>", citySelected, Cards);

  const [cartId, setCartId] = useState("");

  const handleBookNow = (card, loc) => {
    if (loc && loc == "cart") {
      setCartClick(true);
      setCartId(card.id);
    } else {
      setCartClick(false);
    }
    setCardSlug(card.slug);
    dispatch({
      type: SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS,
    });
    onOpenModal();
  };

  const cartDetails = useSelector((state) => state.CartReducer);
  const { loading, cartDetails: cartdata } = cartDetails;

  const responsiveOurService = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  useEffect(() => {
    let newArray = [];
    console.log("NEW ARRAY", newArray);
    // if (cartDetails && cartDetails.cartDetails && cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product) {
    //   console.log("NEW ARRAY",cartDetails.cartDetails[0].product);
    //   cartDetails?.map((item) => {
    //     newArray.push(item.id);
    //   });
    //   setItemInCart(newArray);
    // }
    if (loading) {
      console.log("loading cart detaisl");
    } else {
      console.log("NO NEW ARRAY");
      if (
        cartDetails &&
        cartDetails.cartDetails &&
        cartDetails.cartDetails[0] &&
        cartDetails.cartDetails[0].product
      ) {
        let a = cartDetails.cartDetails[0].product.map((id) => id.package.id);
        // newArray.push(cartDetails.cartDetails[0].product.map(id => id.package.id))
        let b = a.toString();
        let c = parseInt(b);
        newArray.push(c);
        // console.log("NEW ARRAY",cartDetails.cartDetails[0].product.map(id => id.id));
        console.log(
          "NEW ARRAY2",
          cartDetails.cartDetails[0].product.map((data) => data.package.id)
        );
        setItemInCart(newArray);
      } else {
        console.log("NOTHING HAPPENED");
      }
    }
  }, [cartDetails]);

  return (
    <>
      <div className="h2Div">
        {/* <h1>{citySelected}</h1> */}
        <h2>Most Sold/Booked Tests</h2>
      </div>
      <div className="imagingMainDiv">
        <div className="packageListofOurPacakages pkges">
          {/* <div> <h2 style={{fontSize:'2rem',padding:'2rem'}}>Most Sold/Booked Tests</h2></div> */}
          <Carousel
            swipeable={true}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2500}
            transitionDuration={200}
            deviceType={"tablet"}
          >
            {Cards?.map((card) => {
              return (
                <>
                  <div
                    className="Package__card Package__cardNew bgOrdinary "
                    key={card.code}
                  >
                    <div className="packageTopO packageTopHeight">
                      <div className={card.isPremium ? "pTop" : "oTop"}>
                        {/* <div
                          className="cart_div"
                          onClick={() => handleBookNow(card, "cart")}
                        > */}
                        {/* <img src={cart_empty} alt="cart icon" /> */}
                        {/* {console.log("CARD ID IS:", card?.id)}
                          {ItemInCart.includes(card?.id) ? (
                            <img src={cart_fill} alt="cart icon" />
                          ) : (
                            <img src={cart_empty} alt="cart icon" />
                          )} */}
                        {/* </div> */}
                      </div>
                      <div>
                        <div className="Package__cardTitle Package__cardPadding">
                          <span className="textBluee txtBlack">
                            {card.name.length < 47
                              ? card.name
                              : `${card.name.substring(0, 47)}...`}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="packageBottom packageBottomNew">
                      <div className="Package__cardList Package__cardListNew Package__cardListNewImg">
                        <ul>
                          <li>
                            {" "}
                            <img
                              className="checkIconProductListing"
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                              alt=""
                            />{" "}
                            <p>Lady technician available</p>
                          </li>
                          <li>
                            {" "}
                            <img
                              className="checkIconProductListing"
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                              alt=""
                            />{" "}
                            Parking Facility
                          </li>
                          <li>
                            {" "}
                            <img
                              className="checkIconProductListing"
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                              alt=""
                            />{" "}
                            100% Covid safe
                          </li>
                          {/* <li>
                          <FaCheck /> {card.listDesc[1]}
                        </li>
                        <li>
                          <FaCheck /> {card.listDesc[2]}
                        </li> */}
                        </ul>
                      </div>
                      <hr style={{ width: "100%", opacity: "0.3" }} />
                      <div className="Package__cardPrice Package__cardPriceNew">
                        {/* <span className="card__Mrp">
                          MRP : &#8377; {card.package_price}
                        </span>
                        <span
                          className={
                            card.isPremium
                              ? " card__offerPrice  "
                              : " card__offerPrice textGrey textSizeSmall"
                          }
                        >
                          <span style={{ color: "#707070" }}>Starts from</span>{" "}
                          &#8377; {card.offer_price}
                        </span> */}
                        <span className="card__offerPrice textGrey textSizeSmall">
                          Offer Price :
                          <div className="newOfferPriceValue">
                            &#8377; {card.offer_price}{" "}
                            <span className="overlinedPriceNew">
                              &#8377;
                              {card.package_price}
                            </span>
                          </div>
                        </span>
                      </div>

                      {/* <Link
                  className="Package__BookButton"
                  to={`/${
                    card.slug
                  }-${citySelected.citySelect.toLowerCase().replace(" ", "-")}`}
                > */}

                      {/* </Link> */}
                    </div>
                    <div className="newCardBottom">
                      <button
                        className="imagingBtn"
                        onClick={() => {
                          handleBookNow(card);
                        }}
                      >
                        BOOK NOW
                      </button>
                      <div
                        className="cart_div cart_textHeight cart_textHeightImg "
                        onClick={() => handleBookNow(card, "cart")}
                      >
                        <div
                          className={
                            card?.is_premium ? "hover_blue" : "hover_gray"
                          }
                        >
                          {ItemInCart.includes(card?.id) ? (
                            <img
                              className={
                                card?.is_premium
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                              alt="cart icon"
                            />
                          ) : (
                            <img
                              className={
                                card?.is_premium
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                              alt="cart icon"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </Carousel>
          <Modal
            open={open}
            onClose={onCloseModal}
            // center
            classNames={{
              overlay: "customAddressOverlay",
              modal: "customAddressModal",
            }}
          >
            <AddressPopUp
              butname={"SUBMIT"}
              title={"Book Your Test"}
              fromCart={cartClick}
              cartId={cartId}
              position={"Banner"}
              slug={cardSlug}
              Close={onCloseModal}
            />
          </Modal>
        </div>
      </div>
      <div className="testiParentDiv1">
      <div className="childDiv  containerNew">
        <div className="HeaderDiv">
          <div className="divHeading">
            <h2>Our Services</h2>
            <p className="paraWidth">All Imaging Services Under One Roof</p>
          </div>
        </div>
          <div className="mobileImagineDiv">
            <div className="imagineCardRow">
              <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                responsive={responsiveOurService}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2500}
                transitionDuration={200}
              >
                <div className="cardImagine">
                  <img src={card1} />
                  <span className="textBlue">MRI Scan</span>
                </div>
                <div className="cardImagine">
                  <img src={pet} />
                  <span className="textBlue">PET Scan</span>
                </div>

                <div className="cardImagine">
                  <img src={ct} />
                  <span className="textBlue">CT Scan</span>
                </div>

                <div className="cardImagine">
                  <img src={ultrasound} />
                  <span className="textBlue">Ultrasound</span>
                </div>

                <div className="cardImagine">
                  <img src={mamory} />
                  <span className="textBlue">Mammography</span>
                </div>
                <div className="cardImagine">
                  <img src={echo} />
                  <span className="textBlue">ECHO</span>
                </div>
                <div className="cardImagine">
                  <img src={xray} />
                  <span className="textBlue">X-Ray</span>
                </div>
                <div className="cardImagine">
                  <img src={tmt} />
                  <span className="textBlue">TMT</span>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <div className="MobilePackageCard">
        <p>Our Services</p>
        <span>All Imaging Service Under one roof</span>
        <div style={{ margin: "2rem 0px" }}>
          <div className="lpImagingCardServices">
            <img src={mriM} alt="mri" />
            <span>MRI Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={peetM} alt="mri" />
            <span>PET Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={ctM} alt="mri" />
            <span>CT Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={ultrasoundM} alt="mri" />
            <span>Ultrasound</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={mammographyM} alt="mri" />
            <span>Mammography</span>
          </div>

          <div className="lpImagingCardServices">
            <img src={echo} alt="echo" />
            <span>ECHO</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={xray} alt="echo" />
            <span>X-Ray</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={tmt} alt="echo" />
            <span>TMT</span>
          </div>
        </div>
      </div>
    </>
  );
};
function Imaging(props) {
  const [footerTel, setTelNum] = useState("898 898 0101");
  const dispatch = useDispatch();
  const location = useLocation();
  const citySelected = useSelector((state) => state.cityOnTopNav);
  console.log(props.Imgpackage);

  //GETTTING TESTIMONIAL
  useEffect(() => {
    dispatch(Imaginetestimonials());
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/ilp/fb")) {
      setTelNum("898 898 0606");
    } else if (location.pathname.includes("/ilp/sms")) {
      setTelNum("898 898 0606");
    } else if (location.pathname.includes("/ilp")) {
      setTelNum("898 898 0606");
    }
  }, []);

  useEffect(() => {
    console.log("city selected", citySelected.citySelect);
    dispatch(ImagingPackageList(citySelected && citySelected.citySelect));
  }, [citySelected.citySelect]);

  const imaginePackage = useSelector((state) => state.ImgPackagesReducer);
  const imagineTestimonial = useSelector(
    (state) => state.ImaginetestimonialsReducer
  );
  const [testimonial, setTestimonial] = useState([]);

  const { loading: testLoading } = imagineTestimonial;

  // useEffect(() => {
  //   if (testLoading) {
  //   } else {
  //     console.log("testimonial data", imagineTestimonial);
  //     setTestimonial(imagineTestimonial?.testimonials?.results && imagineTestimonial?.testimonials?.results);
  //   }
  // }, [testLoading]);

  console.log("testimonials array", testimonial);

  const { loading: imgLoading } = imaginePackage;
  // console.log(imaginePackage,"hjdh dfjh fdjhhd hdfjhfdjlf")
  //OUR PACKAGES CARDS DATA
  const pacakgesData = [
    {
      id: 1,
      //   img: cross,
      title: "Routine Testing",
      desc: "Routine investigations coverage from wellness to illness",
    },
    {
      id: 2,
      //   img: microscope,
      title: "Pathology Services",
      desc: "Super specialized department to diagnose auto immune disorders",
    },
    {
      id: 3,
      //   img: dna,
      title: "Genomic Testing",

      desc: "Advanced genetic testing to know your health risks",
    },
  ];

  // const ImagingTestimonials = [

  // ];
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const ImagingFaq = [
    {
      id: 1,
      title: "What is an X-ray? ",
      desc:
        "An X-ray is a fast and painless test which involves generating the images of your body structures specifically your bones. It utilizes a small amount of ionizing radiation and is the frequently used form for clinical imaging. X-rays are useful for diagnosing the fractured bones, detects any internal injury and infections like pneumonia, arthritis etc. You should reach out to the Redcliffe Labs to get your X-ray done. We have the most skilled and professional radiologic technologists who ensure performing the examination appropriately and precisely.",
    },
    {
      id: 2,
      title: " What is a CT scan?",
      desc:
        "A Computerized tomography or CT scan is a clinical imaging method used in radiology for getting comprehensive body images for the purpose of diagnosis. Redcliffe Labs have incorporated the use of special equipment with the sophisticated computers for generating images of the complete body.",
    },
    {
      id: 3,
      title:
        "What can you expect while getting your X-ray or any imaging exam done with Redcliffe Labs?",
      desc:
        "Redcliffe Labs have integrated the trained and licensed radiology technologists to perform the radiology examination. According to the exam type, you may be required to lie down, be seated, or stand. There will be the use of an imaging plate for obtaining the image. For better positioning, technologists may involve using the devices which would help you with maintaining the right position. To protect you from radiation, the technologist will be placing the apron over your chest area, pelvic area, and thyroid. You need to hold your breath as well at some points during the process for reducing the probability of blurred images. The technologist will take multiple images from varied angles and you may be asked for the repositioning of different views. ",
    },
    {
      id: 4,
      title:
        "Why do you require a physician’s instruction for an X-ray or other imaging services exam?",
      desc:
        "As per the law, it is crucial to hold the written instruction for any kind of imaging exam. Patients must be assessed only after the physician examination to move forward with the imaging of body parts adequately.",
    },
    {
      id: 5,
      title: "Why can’t you eat or drink anything before any imaging exam?",
      desc:
        "Patients can eat or drink something light for general imaging such as chest, feet, spine and hands. But for other imaging processes patients are asked not to eat or drink. It is for this reason that technologists can perform the best exam on an empty stomach.",
    },
    {
      id: 6,
      title: "How much time does it take for imaging exams?",
      desc:
        "The time limit for every imaging exam is different so here it is: ->>Ultrasound- 30 minutes- 60 minutes, ->>MRI- 15-90 minutes, ->>Mammogram-15 minutes, ->>PET-1-3 hours, ·CT- 10-30 minutes",
    },
    {
      id: 7,
      title: "What imaging exams are offered by Redcliffe Labs?",
      desc:
        "The imaging solutions that we are providing at Redcliffe Labs includes X-ray, MRI scan, PET scan, mammography, ultrasound, and CT scan. ",
    },
  ];

  const [open, setOpen] = useState(false);

  const onOpenModal = () => {
    setOpen(true);
  };
  const onCloseModal = () => setOpen(false);

  const [home, setHome] = useState(false);
  useEffect(() => {
    const size = window.screen.width;
    if (size < 768) {
      setHome(true);
    } else {
      setHome(false);
    }
  }, []);

  useEffect(() => {
    Scroll();
  }, []);

  return (
    <React.Fragment>
      <Meta
        title="Best Radiology & Diagnostic Imaging Center - Redcliffe Labs"
        description="Redcliffe Labs is the best Radiology & Diagnostic Imaging Center that provides a range of radiology tests and screenings at an affordable range. Book your Radiology Test online and get amazing offers."
      ></Meta>
      {/* <TopNav isImagine={true} /> */}

      {/* <NewImagineTop /> */}
      <ImagingNewHeader />
      <div className="imaging_div">
        <div className="imaging_content">
          <h4 className="textPink">#ImagingDoneRight</h4>
          <h1 className="textBlue">Trusted Radiology Lab Network</h1>
          <button onClick={onOpenModal}>BOOK NOW</button>
        </div>
        <div className="imagingImg">
          <img src={sam} alt="modelImg" className="img_fluid"></img>
        </div>
        <div className="ModalDiv">
          <Modal
            open={open}
            onClose={onCloseModal}
            // center
            classNames={{
              overlay: "customOverlay",
              modal: "customModal customModalImaging",
            }}
          >
            {/* <ImagingForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            /> */}
            <ImagingLpForm autoFill={true} push={false} upload={true} />
          </Modal>
        </div>
      </div>
      <div className="mobile_imagingDiv">
        <div className="imaging_content">
          <h4 className="textPink">#ImagingDoneRight</h4>
          <h1 className="textBlue">Trusted Radiology Lab Network</h1>
          {/* <button onClick={onOpenModal}>BOOK NOW</button> */}
        </div>
        <div className="imagingImg">
          <img src={sam} className="img_fluidImg" alt="modelImg"></img>
        </div>
        <div>
          <Modal
            open={open}
            onClose={onCloseModal}
            // center
            classNames={{
              overlay: "customOverlay",
              modal: "customModal customModalImaging",
            }}
          >
            {/* <ImagingForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
              isImagine={true}
            /> */}
            <ImagingLpForm autoFill={true} push={false} upload={true} />
          </Modal>
        </div>
      </div>

      {/**OUR PACKAGES  */}
      {imgLoading
        ? "loading"
        : imaginePackage &&
          imaginePackage.ImgPackages.length > 0 && (
            <Ourpackages Cards={imaginePackage.ImgPackages} />
          )}

      {/**WHY US */}
      <div className="imgWHyus">
        <div className="lifeRedclifee">
          <div className="lifeRedclifee__leftSide">
            <h2>Why Us?</h2>
            <div className="lifeRedclifee__leftSide__content">
              <p className="paraWidth">
                We are proud to provide an expansive range of Imaging tests that
                build preclinical imaging pictures that allow researchers to
                perform top-notch studies in an enhanced laboratory facility.
                The medical team at Redcliffe Imaging has roots in scientific
                research with more than two decades of experience in radiology
                and imaging tests and procedures.
              </p>
              <p className="paraWidth">
                Medical experts at Redcliffe Imaging regularly perform a
                particular medical imaging procedure based on patients’ unique
                symptoms and potential diagnoses. By applying the best of their
                knowledge of technology and human anatomy, technicians capture
                targeted images of various organs, enabling healthcare
                professionals to examine areas of a patient’s body for signs of
                ailment or disease. Several types of medical imaging
                technologies are used in various facets of medicine.
              </p>
            </div>
          </div>
          <div className="lifeRedclifee__rightSide">
            <img src={doc} className="rightMain" alt="right-side-img" />
            {/* <img src={miniLogo} alt="" className="rightMinImg" /> */}
          </div>
        </div>
      </div>

      {/***Contact us */}
      <div className="imgContactus">
        <ContactUsNew 
        email="care@redcliffelabs.com"
        telNumber={footerTel} page={"imaging"} />
      </div>

      {/*** Featured On**/}
      <Featured />

      {/**Testimonial */}

      {/* <Content title="Testimonials" Ispackage={false} static={true} testiArray={ImagingTestimonials} isTestimonial={true} /> */}
      {/* <div className="parentDivv"> */}
      <TestimonialNew />

      {/* </div> */}
      {/* {testLoading ? (
        "loading.."
      ) : imagineTestimonial &&
        imagineTestimonial.testimonials &&
        imagineTestimonial.testimonials.results &&
        imagineTestimonial.testimonials.results.length > 0 ? (
        <div className="NewimagingTest">
          <div className="parentDiv  ">
            <div className="childDiv container">
              <div className="HeaderDiv">
                <div className="divHeading">
                  <h2>Testimonials</h2>
                  <p> </p>
                </div>
              </div>
              <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2500}
                transitionDuration={200}
                deviceType={"tablet"}
              >
                {imagineTestimonial.testimonials.results.map((value) => {
                  return (
                    <div className="Newtestimonial" key={value.id}>
                      <div className="testimonial__card">
                        <div className="testimonial__cardHeader">
                          <img src={value.image} alt="Profile logo"></img>
                          <div className="card__headerUserDetails">
                            <span>
                              {value.title ? (
                                <span>{value.author_name}</span>
                              ) : (
                                <span>nothing</span>
                              )}
                            </span>
                            <span>
                              {value.address ? (
                                <span>
                                  {value.address}, {value.age}
                                </span>
                              ) : (
                                <span> </span>
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="testimonial__cardTitle">
                          <span>"{value.title}"</span>
                        </div>
                        <div className="testimonial__cardFooter">
                          <span>
                            <div>{value.description}</div>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
      ) : null} */}

      {/**FAQ */}
      {/* <div className="accordionNew">
        <h2 className="faq h1style"> FAQs</h2>

        <h2 className="faqs h1style"> Frequently Asked Questions</h2>

        {console.log("screen size ")}
        {ImagingFaq.map((value, index) => (
          <div key={value.id}>
            <FAQstructure value={value} />
          </div>
        ))}
      </div> */}
      <ScrolltoTop />
      <div className="chatbot">
        <SimpleForm />
      </div>
      <ImagingFooter noFaq={true} telNumber={footerTel} screen={home} />
      <div className="SubFooterWrapper">
        <button>
          <a style={{ color: "#e5184e" }} href={`tel:+918988980101`}>
            call now
          </a>
        </button>
        <button
          onClick={onOpenModal}
          style={{ color: "#fff", fontWeight: "600" }}
        >
          Book Now
        </button>

        {/* <ScrolltoTop /> */}
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  Imgpackage: state.getImgPackagesReducer?.ImgPackages,
  Address: state?.getImgPackagesAddressReducer?.ImgPackagesAddress,
});

const mapDispatchToProps = (dispatch) => {
  return {
    ImagingPackageList: (city) => {
      dispatch(ImagingPackageList(city));
    },
  };
};

  export default {
  component: connect(mapStateToProps, mapDispatchToProps)(Imaging),
};

// export default connect(mapStateToProps, mapDispatchToProps)(Imaging);
